import Wrapper from 'components/Wrapper';
import Text from 'components/Text';
import { fontSizes } from 'appconstants';
import { DetailRow } from './components';
import { ReactSVG } from 'react-svg';
import { back_icon } from 'asset/icons';
import { useNavigate } from 'react-router-dom';

const CustomerView = () => {
  const navigate = useNavigate();

  const viewCustomer = {
    // id: params?.id,
    id: 23,
    name: 'James Smith',
    type: 'Store',
    status: 'Active',
    activeAudits: 2,
    completedAudits: 18,
    lastAudit: '12 Aug 2025',
  };

  return (
    <Wrapper>
      <div className='flex items-center gap-3 mb-6'>
        <div
          onClick={() => navigate(-1)}
          className='h-10 w-10 cursor-pointer rounded-md flex items-center justify-center bg-muted hover:bg-muted/50 transition'
        >
          <ReactSVG src={back_icon} />
        </div>

        <Text text={viewCustomer.name} size={fontSizes.h24} className='font-bold' />
      </div>

      <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
        <div className='rounded-xl border bg-white shadow-sm p-5 pt-3 pb-2'>
          <Text text='Customer Details' className='font-bold mb-2' size={fontSizes.h16} />

          <DetailRow label='Customer Name' value={viewCustomer.name} />
          <DetailRow label='Customer Type' value={viewCustomer.type} />
          <DetailRow label='Status' value={viewCustomer.status} />
        </div>

        <div className='rounded-xl border bg-white shadow-sm p-5 pt-3 pb-2'>
          <Text text='Overview' className='font-bold mb-2' size={fontSizes.h16} />

          <DetailRow label='Active Audits' value={String(viewCustomer.activeAudits)} />
          <DetailRow label='Completed Audits' value={String(viewCustomer.completedAudits)} />
          <DetailRow label='Last Audit' value={viewCustomer.lastAudit} />
        </div>
      </div>
    </Wrapper>
  );
};

export default CustomerView;
